import React from "react";
import { HiddenVisually } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import { useSearchboxStore } from "../../store/searchBoxStore.js";
import { useFareCalendarEnabled } from "./useFareCalendar.js";
const FareCalendarLoadingAnnouncement = ({ segmentIndex, fareCalendarConfig, mode }) => {
    const i18n = useI18n();
    const store = useSearchboxStore();
    const loading = store.searchbox.fareCalendar.loading;
    const fareCalendarEnabled = useFareCalendarEnabled(segmentIndex, fareCalendarConfig, mode);
    if (!fareCalendarEnabled) {
        return null;
    }
    return (React.createElement(HiddenVisually, null,
        React.createElement("div", { "aria-live": "assertive" }, loading
            ? i18n.trans(t("a11y_flights_fare_cal_loading"))
            : i18n.trans(t("a11y_flights_fare_cal_loading_complete")))));
};
export default FareCalendarLoadingAnnouncement;
